import { BodyOf } from "../../../core/api";

export type Disposition = BodyOf<
  "post",
  "./visit_daily_notes/approve"
>["determinations"][number]["dispositions"][number];

/**
 * What the reviewer did, in the order a reviewer thinks about it: least action first.
 *
 * The labels live here and the codes go to the server, so the wording can be revised
 * without touching what a signed record stores. The order is presentation only.
 *
 * Shared by the modal that records a disposition and the one that reads it back, so
 * the same code cannot be worded two ways on two screens.
 */
export const DISPOSITIONS: { value: Disposition; label: string }[] = [
  { value: "NO_ACTION_REQUIRED", label: "No action required" },
  { value: "CAREGIVER_CLARIFICATION", label: "Caregiver clarification" },
  { value: "CAREGIVER_COACHING", label: "Caregiver coaching" },
  { value: "CARE_PLAN_REASSESSMENT", label: "Care-plan reassessment" },
  { value: "CONTACT_PCP", label: "Contact PCP" },
  { value: "NOTIFY_CASE_MANAGER", label: "Notify case manager" },
  { value: "INCIDENT_EVALUATION", label: "Incident evaluation" },
  { value: "URGENT_CLINICAL_ESCALATION", label: "Urgent clinical escalation" },
];

/**
 * The wording for a stored code.
 *
 * Falls back to the code itself rather than to an empty string: a record written by a
 * build that knew an option this one does not is better shown raw than silently
 * dropped from a signed document.
 */
export function dispositionLabel(value: string): string {
  return DISPOSITIONS.find((option) => option.value === value)?.label ?? value;
}
